import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

const MobileNavigation = ({ HeaderData }) => {
  const navigate = useNavigate();

  const resetOffcanvasState = () => {
    const offcanvasElements = document.querySelectorAll(".offcanvas");
    const backdrops = document.querySelectorAll(".offcanvas-backdrop");
    const toggleButtons = document.querySelectorAll(
      '[data-bs-toggle="offcanvas"]'
    );

    // Remove any stuck backdrop
    backdrops.forEach((backdrop) => backdrop.remove());

    // Reset offcanvas elements
    offcanvasElements.forEach((element) => {
      element.classList.remove("show");
      element.style.visibility = "";
      element.removeAttribute("aria-modal");
      element.removeAttribute("role");
    });

    // Reset toggle buttons
    toggleButtons.forEach((button) => {
      button.setAttribute("aria-expanded", "false");
    });

    // Clean up body
    document.body.classList.remove("modal-open");
    document.body.style.removeProperty("overflow");
    document.body.style.removeProperty("padding-right");
  };

  const handleNavigation = (link, hasSubmenu) => {
    if (!hasSubmenu) {
      // First reset the offcanvas state
      resetOffcanvasState();

      // Then navigate
      setTimeout(() => {
        navigate(link);
      }, 50);
    }
  };

  // Add cleanup on component mount and unmount
  useEffect(() => {
    const cleanup = () => {
      resetOffcanvasState();
    };

    // Clean up on mount (in case of lingering state)
    cleanup();

    // Clean up on unmount
    return cleanup;
  }, []);

  return (
    <div className="offcanvas-body">
      <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <div className="container-fluid">
          <ul className="navbar-nav">
            {HeaderData.map((data, index) => (
              <li
                className={`nav-item ${data.submenu ? "dropdown" : ""}`}
                key={index}
              >
                <Link
                  to={data.link}
                  onClick={(e) => {
                    if (data.submenu) {
                      e.preventDefault();
                    } else {
                      e.preventDefault();
                      handleNavigation(data.link, false);
                    }
                  }}
                  className={`nav-link ${
                    data.submenu ? "dropdown-toggle" : ""
                  }`}
                  id={`dropdown${index}`}
                  role={data.submenu ? "button" : ""}
                  data-bs-toggle={data.submenu ? "dropdown" : ""}
                  aria-expanded="false"
                >
                  {data.menu}
                  {data.submenu && <i className="ms-1"></i>}
                </Link>
                {data.submenu && (
                  <ul
                    className="dropdown-menu"
                    aria-labelledby={`dropdown${index}`}
                  >
                    {data.subMenuitem.map((item, index1) => (
                      <li
                        className={`dropdown ${
                          item.subItems ? "dropdown-submenu" : ""
                        }`}
                        key={index1}
                      >
                        <Link
                          to={item.linkL}
                          onClick={(e) => {
                            if (item.subItems) {
                              e.preventDefault();
                            } else {
                              e.preventDefault();
                              handleNavigation(item.linkL, false);
                            }
                          }}
                          className={`dropdown-item ${
                            item.subItems ? "dropdown-toggle" : ""
                          }`}
                          id={`nestedDropdown${index1}`}
                          role={item.subItems ? "button" : ""}
                          data-bs-toggle={item.subItems ? "dropdown" : ""}
                          aria-expanded="false"
                        >
                          {item.subItem}
                          {item.subItems && <i className="ms-1"></i>}
                        </Link>
                        {item.subItems && (
                          <ul className="dropdown-menu">
                            {item.subItems.map((item1, index2) => (
                              <li key={index2}>
                                <Link
                                  to={item1.link}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleNavigation(item1.link, false);
                                  }}
                                  className="dropdown-item"
                                >
                                  {item1.item}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </div>
      </nav>
    </div>
  );
};

export default MobileNavigation;
